// extracted by mini-css-extract-plugin
module.exports = {"main":"Base_main__1a4Jo","image":"Base_image__31Hz8"};